type ISorter<SortElement> = (a: SortElement, b: SortElement) => number;
export function orderedSort<SortElement>(...sorts: ISorter<SortElement>[]): ISorter<SortElement> {
  return (a, b) => {
    return sorts
      .map((sort) => {
        const sortResult = sort(a, b);
        switch (true) {
          case sortResult > 0:
            return 1;
          case sortResult < 0:
            return -1;
          default:
            return 0;
        }
      })
      .map((result, index) => result * Math.pow(10, sorts.length - 1 - index))
      .reduce((total, result) => result + total, 0);
  };
}
